<template lang="pug">
    #app(ref='app-container')
        .container-wrapper
            // header
            .header
                .animation-before.animation-after
                    .header-logo
                    .header-title 南京医基云医疗数据研究院
                    .header-abstract
                        span 深度洞察生命密码
                        span(style='margin-left: 60px') 精准探究疾病规律
                    .header-abstract-english We Integrate Biomedical Data for Better Healthcare
                    .icon.icon-go-down.opacity-animation

            // 关于医基云
            .abort-box.animation-before(ref='abort')
                .title 关于医基云
                .text 南京医基云医疗数据研究院，立足于南京江北新区医疗健康大数据中心，重点开展生物信息算法的开发、临床数据和基因数据的整合、疾病模型的构建以及深度数据的挖掘，推动以数据为基础、算法为核心的数据整合的产品和服务。


            // content
            .content
                // 业务模式
                .section.business
                    .animation-before(ref='business')
                        .title 业务模式
                        .abstract 基于南京医基云医疗数据研究院先进的后结构化技术，提供基于临床数据和基因数据的自动化字段标注、知识挖掘、科研引导等服务；整合临床数据和基因数据，建立和完善标准化数据分析流程，利用人工智能构建医疗健康大数据模型，助力精准医疗
                        img.business-image(src='~assets/images/business.png')


                // 创新应用模块
                .section.application
                    .animation-before(ref='application')
                        .title 创新应用
                        .abstract 以咨询、研发、科研服务为主线，建立临床数据和基因数据融合的健康大数据平台，使医学数据得到充分的利用和转化，真正服务真实世界研究
                        el-row.list
                            el-col(
                                v-for='(item, index) in applicationList'
                                :key='item.img'
                                :span='24 / applicationList.length'
                                :style='{"background-image": "url(" + item.img + ")"}'
                                :class='"list-item list-item-" + index')
                                .icon(:class='item.icon' :style='{"font-size": item.size}')
                                .title(:style='{"margin-top": item.marginTop}') {{ item.title }}
                                .subtitle {{ item.subtitle }}


                // 市场和产品功能
                .section.function
                    .animation-before(ref='function')
                        .title 市场定位和产品功能
                        .abstract 医基云基于临床数据和基因数据的分析系统，对临床数据和基因数据进行深度处理和挖掘，可满足辅助诊疗、真实世界数据研究、患者随访、不良反应监测等应用场景，将推动对包括肿瘤、遗传性疾病、辅助生殖、感染性疾病等的诊断和治疗方法的开发、优化临床试验的设计和执行。基于真实世界数据研究的肿瘤临床和基因突变信息，助力更有效的新药评估，加速新药上市
                        img.func-image(src='~assets/images/func.png')
                        el-row.list
                            el-col(
                                v-for='(item, index) in functions'
                                :key='index'
                                :span='4')
                                p(v-for='subtitle in item.title' :key='subtitle') {{ subtitle }}


                // 专家团队
                .section.motivation
                    .animation-before(ref='motivation')
                        .title 专家团队
                        .abstract 南京医基云医疗数据研究院诚邀业内知名专家共建，以开放的运营机制、完善的人才激励方案，吸引了众多优秀的技术人才、技术团队加入研究院，推动中国精准医疗事业的发展
                        //.abstract 南京医基云医疗数据研究院由美国斯坦福大学教授王永雄院士领衔，邀请业内知名专家共建，以开放的运营机制、完善的人才激励方案，吸引了众多优秀的技术人才、技术团队加入研究院，推动中国精准医疗事业的发展
                        //- el-row.list
                            el-col(
                                v-for='(item, key) in people'
                                :key='item.name'
                                :span='5')
                                img.avatar(:src='item.avatar')
                                .name {{ item.name }}
                                .brife
                                    p(v-for='(brie, index) in item.brife' :key='index') {{ brie }}
                                .detail
                                    .detail-content-wrapper(:ref='`detailContent-${key}`')
                                        .name {{ item.name }}
                                        .brife
                                            p(v-for='(brie, index) in item.brife' :key='index') {{ brie }}
                                        .detail-content
                                            span {{ item.detail[0] }}
                                            span {{ item.open === false ? '...' : item.detail[1] }}
                                            .open(
                                                v-if='item.detail.length > 1'
                                                @click='handleOpenClick(item, key)'
                                                :style='!item.open ? "margin-left: 10px" : ""')
                                                span.text {{ item.open ? '收起 ' : '展开 ' }}
                                                i(:class='item.open ? "icon-arrow-up" : "icon-arrow-down"')

                // 携手共创
                .section
                    .animation-before(ref='cooperation')
                        .title 携手共创
                        .abstract 学术交流 、人才引进、项目共建、开放合作
                        .logo-list
                            img(
                                v-for='item in cooperations'
                                :key='item.img'
                                :src='item.img'
                                :style='{width: item.width, height: item.height, "margin-left": item.marginLeft || 0}')

            // copyright
            .footer
                p 南京市江北新区浦滨路211号扬子科创中心A幢15层1502&nbsp;&nbsp;&nbsp;&nbsp;市场合作：marketing@yigencloud.cn
                p.copyright
                    span ©2019 南京医基云医疗数据研究院有限公司版权所有 |
                    span
                        span 网站备案/许可证号：
                        a(href='http://beian.miit.gov.cn') 苏ICP备19028338号-1
                    img.keep-on-record(src='~assets/images/keep-on-record.png' width='14px' height='14px')
                    span
                        span 苏公网安备
                        a(href='http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32011202000266' target='_blank')  32011202000266
</template>


<script>
import { APP_LIST, PEOPLE, COOPERATIONS, FUNCTIONS } from '@/config/data-config';
export default {
    name: 'app',
    data () {
        return {
            applicationList: APP_LIST,
            people: PEOPLE,
            cooperations: COOPERATIONS,
            functions: FUNCTIONS,
        };
    },
    components: {
    },
    mounted () {
        const observer = new IntersectionObserver(changes => {
            for (const change of changes) {
                if (change.intersectionRatio > 0) {
                    change.target.classList.add('animation-after');
                }

                // if (change.intersectionRatio === 0) {
                //     change.target.className = change.target.className.replace('animation-after', '');
                // }
            }
        }, {
            root: this.$refs['app-ontainer'],
        });

        observer.observe(this.$refs.abort);
        observer.observe(this.$refs.business);
        observer.observe(this.$refs.application);
        observer.observe(this.$refs.function);
        observer.observe(this.$refs.motivation);
        observer.observe(this.$refs.cooperation);
    },
    methods: {
        /**
         * @function handleOpenClick
         * @description 展开收起按钮点击事件
         *
         * @param {Object} 点击项所对应的数据项
         * @param {integer} 索引
         */
        handleOpenClick (item, index) {
            item.open = !item.open;
            const $el = this.$refs['detailContent-' + index];
            this.$nextTick(() => {
                $el[0].scrollTop = 300;
            });
        }
    },
}
</script>

<style>
#app {
    height: 100%;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
</style>
<style lang="sass" scoped>
    .container-wrapper
        min-width: 1320px
        // height: 100%
        font-size: 24px
        line-height: 36px
        text-align: center
        color: #000
        .header
            position: relative
            padding-top: 67px
            height: 700px
            font-weight: 700
            background-image: url('./assets/images/header.jpg')
            background-size: 100% 100%
            color: #fff
            .header-logo
                margin: auto
                width: 152px
                height: 50px
                background-image: url('./assets/images/logo-white.png')
                background-size: 100% 100%
            .header-title
                margin-top: 90px
                font-size: 36px
            .header-abstract
                margin-top: 60px
                font-size: 56px
                line-height: 94px
            .header-abstract-english
                font-size: 32px
            .icon-go-down
                margin: auto
                margin-top: 100px
                font-size: 34px
                line-height: 34px
                opacity: 1
                color: #fff

        .abort-box
            border-radius: 14px
            position: absolute
            top: 608px
            z-index: 2
            left: 0
            right: 0
            font-weight: 400
            padding: 52px 65px
            margin: auto
            width: 1290px
            height: 270px
            color: #000
            box-shadow: 0 6px 20px 0 rgba(0, 0, 0, .06)
            background: #fff
            .title
                position: relative
                font-size: 28px
                font-weight: 700
                color: #29323e
                &:before,
                &:after
                    content: ''
                    position: absolute
                    margin: auto
                    left: 0
                    right: 240px
                    top: 18px
                    width: 80px
                    height: 1px
                    background: #D5D5D5
                &:after
                    left: 240px
                    right: 0
            .text
                margin-top: 39px
                font-size: 20px
                line-height: 30px
                text-align: justify


        // content
        .content
            position: relative
            .section
                padding-top: 200px
                margin: auto
                font-size: 18px
                line-height: 28px
                &:first-child
                    background: -webkit-linear-gradient(to bottom, #f8fafc , #fff)
                    background: -moz-linear-gradient(to bottom, #f8fafc , #fff)
                    background: -o-linear-gradient(to bottom, #f8fafc , #fff)
                    background: linear-gradient(to bottom, #f8fafc , #fff)
                .title
                    font-size: 40px
                    font-weight: 700
                .abstract
                    margin: auto
                    margin-top: 24px
                    color: #29323e
                .list
                    margin: auto
                    margin-top: 80px
                    max-width: 1320px
                    .el-col
                        position: relative
                        height: 400px
                        &:first-child
                            margin-left: 0
                        &:last-child
                            margin-right: 0
                    .el-col-6
                        margin: 0 1.163%
                        width: 23.256%
                        padding: 74px 47px 71px
                        background-size: 100% 100%
                        color: #fff
                    .el-col-5
                        border: 1px solid #d5d5d5
                        margin: 0 .926%
                        width: 18.519%
                        padding: 60px 28px 45px
                        overflow-y: hidden
                    .el-col-4
                        margin: 0 88px
                        width: 198px
                        height: 52px
                        font-size: 16px
                        &:last-child
                            padding-left: 25px
                        &:first-child
                            padding-left: 30px
                            text-align: left

                    .title
                        margin-top: 28px
                        font-size: 24px
                    .subtitle
                        margin: auto
                        margin-top: 25px
                        width: 208px
                        font-size: 16px
                        line-height: 24px
                    .icon
                        margin: auto

                    .avatar
                        width: 140px
                        height: 140px
                    .name
                        margin-top: 12px
                        font-size: 18px
                        font-weight: 700
                        line-height: 34px
                    .brife
                        margin-top: 20px
                        font-size: 16px
                        line-height: 24px
                    .detail
                        transform: translateY(100%)
                        transition-duration: 100ms
                        position: absolute
                        top: 0
                        right: 0
                        bottom: 0
                        left: 0
                        font-size: 16px
                        line-height: 24px
                        text-align: justify
                        color: #fff
                        background-color: rgba(84, 124, 192, 0.89)
                        .name,
                        .brife
                            text-align: center
                        .brife
                            margin-top: 10px
                        .detail-content-wrapper
                            opacity: 0
                            height: 317px
                            overflow: hidden
                            padding: 0 28px
                            margin-top: 36px
                            -webkit-transition: opacity 500ms
                                    transition: opacity 500ms

                        .detail-content-wrapper::-webkit-scrollbar
                            display: none
                        .detail-content
                            position: relative
                            margin-top: 18px
                            .open
                                display: inline-block
                                font-size: 14px
                                cursor: pointer
                                position: relative
                                bottom: 2px
                                .text
                                    text-decoration: underline
                                    vertical-align: middle
                                    font-weight: 700
                            .icon-arrow-down,
                            .icon-arrow-up
                                margin-left: 2px
                                text-decoration: none
                                vertical-align: middle
                    .el-col:hover
                        .detail
                            transform: translateY(0)
                            .detail-content-wrapper
                                transition-delay: 100ms
                                opacity: 1

            .business
                padding-top: 360px
                padding-bottom: 142px
                .abstract
                    width: 1162px
                .business-image
                    margin-top: 80px
                    max-width: 1320px
            .application
                .abstract
                    width: 825px
                .list-item
                    margin-top: 10%!important
                .animation-after
                    .list-item
                        margin-top: 10%!important
                        -webkit-transition: margin-top 1s
                                transition: margin-top 1s
                    .list-item-0,
                    .list-item-1,
                    .list-item-2,
                    .list-item-3
                        margin-top: 0!important
                    .list-item-0
                        transition-delay: 50ms
                    .list-item-1
                        transition-delay: 100ms
                    .list-item-2
                        transition-delay: 150ms
                    .list-item-3
                        transition-delay: 200ms

            .function
                .abstract
                    width: 1168px
                .func-image
                    margin-top: 80px
                    width: 1280px
                    height: 338px
                .list
                    margin-top: 30px
                    font-weight: 700
            .motivation
                .abstract
                    width: 973px

            .logo-list
                margin: auto
                margin-top: 80px
                max-width: 1320px
                img
                    vertical-align: middle


        // copyright
        .footer
            margin-top: 158px
            padding: 22px 0
            height: 92px
            font-size: 14px
            line-height: 24px
            color: rgba(255, 255, 255, .8)
            background-color: #273143
            .copyright
                font-size: 12px
                .keep-on-record
                    position: relative
                    top: 2px
                    margin-left: 5px
                    margin-right: 2px


    .animation-before
        transform: translateY(10%)
    .animation-after
        transform: translateY(0)
        -webkit-animation: trans .5s
                animation: trans .5s

    .opacity-animation
        opacity: .5
        -webkit-animation: op 2s infinite
                animation: op 2s infinite

    @keyframes trans
        from
            transform: translateY(10%)
        to
            transform: translateY(0)
    @-webkit-keyframes trans
        from
            transform: translateY(10%)
        to
            transform: translateY(0)

    @keyframes op
        0%
            opacity: .8
        50%
            opacity: .1
        100%
            opacity: .8
    @-webkit-keyframes op
        0%
            opacity: .8
        50%
            opacity: .1
        100%
            opacity: .8

</style>

